import { BROKER_LOGO, CURRENT_BROKER } from "@/config/logos";

const FavIconsMeta = () => {
  return (
    <>
      <link
        rel="apple-touch-icon"
        sizes="57x57"
        href={BROKER_LOGO[CURRENT_BROKER].DARK.textLogo}
      />
      <link
        rel="apple-touch-icon"
        sizes="60x60"
        href={BROKER_LOGO[CURRENT_BROKER].DARK.textLogo}
      />
      <link
        rel="apple-touch-icon"
        sizes="72x72"
        href={BROKER_LOGO[CURRENT_BROKER].DARK.textLogo}
      />
      <link
        rel="apple-touch-icon"
        sizes="76x76"
        href={BROKER_LOGO[CURRENT_BROKER].DARK.textLogo}
      />
      <link
        rel="apple-touch-icon"
        sizes="114x114"
        href={BROKER_LOGO[CURRENT_BROKER].DARK.textLogo}
      />
      <link
        rel="apple-touch-icon"
        sizes="120x120"
        href={BROKER_LOGO[CURRENT_BROKER].DARK.textLogo}
      />
      <link
        rel="apple-touch-icon"
        sizes="144x144"
        href={BROKER_LOGO[CURRENT_BROKER].DARK.textLogo}
      />
      <link
        rel="apple-touch-icon"
        sizes="152x152"
        href={BROKER_LOGO[CURRENT_BROKER].DARK.textLogo}
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={BROKER_LOGO[CURRENT_BROKER].DARK.textLogo}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="192x192"
        href={BROKER_LOGO[CURRENT_BROKER].DARK.textLogo}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={BROKER_LOGO[CURRENT_BROKER].DARK.textLogo}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="96x96"
        href={BROKER_LOGO[CURRENT_BROKER].DARK.textLogo}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={BROKER_LOGO[CURRENT_BROKER].DARK.textLogo}
      />
      <link rel="manifest" href={`/manifest.json`} />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta
        name="msapplication-TileImage"
        content={BROKER_LOGO[CURRENT_BROKER].DARK.textLogo}
      />
      <meta name="theme-color" content="#ffffff" />
    </>
  );
};
export default FavIconsMeta;
